












import Vue from "vue"
import WideStaticNotice from "~/components/guideline/notice/WideStaticNotice.vue"

export default Vue.extend({
  components: {
    WideStaticNotice,
  },
  props: {
    alertText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    openSignupPage() {
      this.$nuxt.$router.push({ path: "/signup" })
    },
  },
})
